class ContactForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    const params = new URLSearchParams(window.location.search)
    const enquiry = params.get('enquiry')

    if (!enquiry) return

    if (this.els.message.exists) {
      this.els.message.element.value = enquiry
    }

    if (this.els.subject.exists) {
      const subjectElement = this.els.subject.element
      const productOption = Array.from(subjectElement.options).find(
        (option) => option.value.trim() === 'Product',
      )

      if (productOption) subjectElement.value = productOption.value
    }
  }
}

if (!customElements.get('contact-form')) {
  customElements.define('contact-form', ContactForm)
}
